import { z } from 'zod';

export const localeSchema = z.object({
  id: z.string(),
  code: z.string(), // BCP 47 tag (e.g. 'en', 'hi', 'te')
  name: z.string(),
  isActive: z.boolean(),
  isDefault: z.boolean(),
});
export type Locale = z.infer<typeof localeSchema>;
